import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { RegisterModel } from '../../../api/register/register';
import { RegisterService } from '../../../api/register/register.service';
declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
    selector: 'register-page',
    templateUrl: './register.html'
})
export class RegisterComponent implements OnInit {
    adminList: RegisterModel[];
    admin: RegisterModel;
    userType: String = "ADMIN";
    emailId: String;
    mobileno: Number;
    password: String;
    repassword: String;
    roleType: string;
    thisUserId: string;
    id: string;
    i: number;
    message: string;
    resRegister: any;
    adActive: boolean;
    constructor(private registerService: RegisterService, private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN')) {
            $(function () {
            });
            this.initRegister();
        } else {
            this.router.navigate(['/']);
        }
    }
    initRegister() {
        this.roleType = localStorage.getItem('type');
        this.thisUserId = localStorage.getItem('id');
        this.registerService
            .allAdmin()
            .then(
                data => this.adminList = data
            );
    }
    cancelAction() {
        this.emailId = "";
        this.mobileno = null;
        this.repassword = "";
        this.password = "";
    }
    eventEmail(event, email) {
        var _event = event || window.event;
        var key = _event.keyCode || _event.which;
        if (key == 64) {
            var count = this.emailId.toString().split("@").length;
            if (count == 1)
                return true;
            else
                return false;
        }
        if (key == 46)
            return true;
        if (48 <= key && key <= 57)
            return true;
        if (65 <= key && key <= 90)
            return true;
        if (97 <= key && key <= 122)
            return true;
        return false;
    }
    eventPassword(event) {
        // var _event = event || window.event;
        // var key = _event.keyCode || _event.which;
        // if (48 <= key && key <= 57)
        //     return true;
        // if (65 <= key && key <= 90)
        //     return true;
        // if (97 <= key && key <= 122)
        //     return true;
        // return false;
    }
    eventNumber(e) {
        var regex = new RegExp("^[0-9]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }
        e.preventDefault();
        return false;
    }
    iRegister() {
        if (this.emailId == undefined || this.emailId == "" || this.emailId == null) {
            this.password = "";
            this.repassword = "";
            $.notify({
                message: "Please Enter Email id"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.mobileno == undefined || this.mobileno.toString() == "") {
            $.notify({
                message: "Please Enter Mobile No"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.password == undefined || this.password == "" || this.password == null) {
            this.password = "";
            this.repassword = "";
            $.notify({
                message: "Please Enter Password"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.repassword == undefined || this.repassword == "" || this.repassword == null) {
            $.notify({
                message: "Please Enter Re-Password"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.repassword != this.password) {
            this.password = "";
            this.repassword = "";
            $.notify({
                message: "Password is not match"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        }
        else if (this.password.length < 6) {
            this.password = "";
            this.repassword = "";
            $.notify({
                message: "Password must be more than six Character"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        }
        else {
            let registeruser = {
                mobile: this.mobileno,
                email: this.emailId,
                password: this.password,
                role: this.userType,
                createdById: this.thisUserId,
            }
            this.registerService
                .iAdmin(registeruser)
                .then(data => {
                    if (data.status == true) {
                        this.message = data.message
                        this.adminList.push(data.data);
                        $.notify({
                            message: this.message
                        }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                        this.cancelAction();
                        $(function () {
                            $("#example3").modal('toggle');
                        });
                    } else {
                        this.message = data.message
                        $.notify({
                            message: this.message
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                    }
                });
        }
    }
    showAdmin(admin, i) {
        this.i = i;
        this.admin = admin;
        this.id = admin.id;
        this.emailId = admin.email;
        this.mobileno = admin.mobile;
        this.password = admin.password;
        this.userType = admin.role;
    }
    updateAdmin() {
        if (this.password == "" || this.password == null || this.password == undefined) {
            $.notify({
                message: "Please Enter Password"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            this.cancelAction()
        }
        else {
            var uRegister = {
                email: this.emailId,
                mobile: this.mobileno,
                password: this.password,
                role: this.userType,
                updatedById: this.thisUserId
            }
            this.registerService
                .uAdmin(this.id, uRegister)
                .then(data => {
                    if (data.status == true) {
                        this.message = data.message
                        this.initRegister();
                        $.notify({
                            message: this.message
                        }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                        this.cancelAction()
                        $(function () {
                            $('#exampleModal').modal('toggle');
                        });
                    } else {
                        this.message = data.message
                        $.notify({
                            message: this.message
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                    }
                });
        }
    }
    deactiveAdmin(id, i, admin) {
        var _isactive = 0;
        if (admin.isactive == true) {
            _isactive = 0;
        }
        else {
            _isactive = 1;
        }
        var aAdmin = {
            isactive: _isactive
        }
        this.registerService
            .dAdmin(id, aAdmin)
            .then(data => {
                if (data.status == true) {
                    this.message = data.message
                    this.adminList[i].isactive = data.data.isactive;
                    $.notify({
                        message: this.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    this.cancelAction()
                } else {
                    this.message = data.message
                    $.notify({
                        message: this.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/register/register.page.ts